import React from 'react'
import Link from 'next/link'
import Button from '../../atoms/Button/Button'

const ServiceGiftCard = ({ title, description, cta, link }) => {
  return (
    <div className="service-gift-card">
      <p className="service-gift-card__title">{title}</p>
      <p>{description}</p>
      <Link legacyBehavior href={link}>
        <a>
          <Button variant={'primary'} label={cta} className="service-gift-card__cta" />
        </a>
      </Link>
    </div>
  )
}

export default ServiceGiftCard
